module.exports = __webpack_public_path__ + "static/media/Quicksand-Medium.f65d1a07.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quicksand-Medium.ttf
// module id = 3567
// module chunks = 68